import parse from "date-fns/parse";
import format from "date-fns/format";
import addDays from "date-fns/add_days";
import subDays from "date-fns/sub_days";
import getDay from "date-fns/get_day";

export const datesBetween = (_start, _stop) => {
  if (!(_start instanceof Date)) _start = new Date(_start);
  if (!(_stop instanceof Date)) _stop = new Date(_stop);

  let [start, stop] = [_start, stop].map(parse).sort();

  const dates = [];

  while (start <= stop) {
    dates.push(start);
    start = addDays(start, 1);
  }

  return dates;
};

export const isoFormat = date => format(date, "YYYY-MM-DD");

export const dayOfWeekBefore = (date, day = 1) => {
  let delta = getDay(date) - day;

  if (delta < 0) delta += 8;

  return subDays(date, delta);
};

export const mondayBefore = date => dayOfWeekBefore(date, 1);



// WEBPACK FOOTER //
// ./src/components/Calendar/helpers.js